module.exports = __webpack_public_path__ + "images/emoji/heartbeat.a68a5978883d12ff5fe9.png";